import { createSlice } from '@reduxjs/toolkit';

// Define the initial state using that type
const initialState: IInfraDeviceState = {
    data: null,
    pageSize: 0,
    pageNumber: 0,
    totalCount: 0,
    showLoading: {
        sourceAction: '',
        state: false,
    },
    isLoading: false,
    isSuccess: false,
    details: null
};

export const infraDeviceSlice = createSlice({
    name: 'infraDevice',
    // `createSlice` will infer the state type from the `initialState` argument
    initialState,
    reducers: {
        setLoading: (state, action) => {
            const { isLoading, isSuccess } = action.payload;
            state.showLoading = {
                sourceAction: action.payload.sourceAction,
                state: true,
            };
            state.isLoading = isLoading ? isLoading : false;
            state.isSuccess = isSuccess ? isSuccess : false;
        },
        resetLoading: (state, action) => {
            const { isLoading, isSuccess } = action.payload;
            state.showLoading = {
                sourceAction: '',
                state: false,
            };
            state.isLoading = isLoading ? isLoading : false;
            state.isSuccess = isSuccess ? isSuccess : false;
        },
        replaceInfraDevice: (state, action) => {
            const { data, pageSize, pageNumber, totalCount } = action.payload;
            state.data = data;
            state.pageSize = pageSize;
            state.pageNumber = pageNumber;
            state.totalCount = totalCount;
        },
        addInfraDevice: (state, action) => {
            const newItem = action.payload.data;
            if (state.data && state.data.length > state.pageSize) {
                state.data.pop();
            }
            state.data = state.data ? [newItem, ...state.data] : [newItem];
            state.totalCount = state.totalCount + 1;
        },
        updateInfraDevice: (state, action) => {
            const { localID, data } = action.payload;
            if (localID !== undefined && localID >= 0 && state.data) {
                state.data[localID] = data;
            }
            state.details = data;
        },
        deleteInfraDevice: (state, action) => {
            const toRemove: IInfraDevice = action.payload.data;
            const newData = state.data && state.data.filter(
                (infraDevice: IInfraDevice) => {
                    return (
                        infraDevice.id !== toRemove.id
                    );
                }
            );
            state.data = newData;
            state.totalCount = state.totalCount - 1;
        },
        setInfraDeviceDetails: (state, action) => {
            state.details = action.payload.data;
        }
    },
});

export const infraDeviceActions = infraDeviceSlice.actions;

export default infraDeviceSlice.reducer;
